<template>
  <li class="dkillItem" @click="enterDetails(item)">
    <div class="cover-img">
      <img :src="item.coverMobile" alt="" />
      <div class="time" v-if="item.startTime">开课时间：{{ eplaceHyphens(item.startTime) }}</div>
      <div class="promotionLabel" v-if="item.promotionLabel == 2">
        <p>{{ showTime }}</p>
      </div>
    </div>
    <p class="dkillTitle">
      <i v-if="item.name && item.name.substr(0, 1) == '【'"></i>{{ item.name }}
    </p>
    <div class="activityTag">
      <span v-for="(tagItem, tagIndex) in tagType(item)" :key="tagIndex" :text="tagItem">{{
        tagItem
      }}</span>
    </div>
    <div class="TimeHours">
      <p class="hourse" v-if="item.classPeriod">共{{ item.classPeriod }}课时</p>
      <p class="Time">{{ item.salesVolume }}人报名</p>
    </div>
    <ol class="foot">
      <!-- 售价 -->
      <div class="coursePrice">
        <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
        <p class="showPic">
          <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
            <b>¥</b>
            <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
          </template>
          <template v-else>
            <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
            <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
              item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
            }}</span>
          </template>
        </p>
      </div>
      <div class="addShopping" @click.stop.prevent="addBook($event, item)"></div>
    </ol>
  </li>
</template>

<script>
import wx from 'weixin-js-sdk';
import { replaceHyphens, timerYhqCount } from '@/utils/tools';

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showTime: '',
      timers: null,
    };
  },
  computed: {
    tagType() {
      return (val) => {
        const type = [];
        if (val.isUnionDiscount) {
          type.push('联报优惠');
        }
        if (val.isSingleDiscount) {
          type.push('单减活动');
        }
        if (val.isCouponDiscount) {
          type.push('优惠券');
        }
        if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
          type.push('满减活动');
        }
        // 增加购课增好礼标签
        if (val.productDiscountRespVO && val.productDiscountRespVO.isBuyGiftGiveawaysDiscount) {
          type.push('购课赠好礼');
        }
        if (val?.isEbook) {
          type.push('电子书');
        }
        return type;
      };
    },
  },
  methods: {
    coursePriceDel(item) {
      return item.productDiscountRespVO.isGroupDiscount || item.promotionLabel;
    },
    eplaceHyphens(timeStr) {
      return timeStr?.replace(/-/g, '.')?.slice(0, 11);
    },
    enterDetails(courseInfo) {
      const { productId } = courseInfo;
      this.$router.push({
        path: '/studyBookExperience',
        query: {
          courseId: productId,
        },
      });
    },
    addBook(event, item) {
      this.$emit('addBook', { event: event.target, item });
    },
    // 倒计时
    countTime() {
      const { acvitityEndTime } = this.item;
      if (!acvitityEndTime) return;
      // 当前时间戳
      const now = new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(acvitityEndTime)).getTime();
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp, 1);
        } else {
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.countTime();
    });
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  position: relative;
  box-sizing: border-box;
  width: 288px;
  min-height: 424px;
  // height: max-content;
  margin-bottom: 22px;
  background: #fff;
  border-radius: 14px;
}
.cover-img {
  position: relative;
  width: 288px;
  height: 192px;
  img {
    width: 288px;
    height: 192px;
    border-radius: 14px;
  }
  .time {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 33px;
    color: #fff;
    font-weight: 400;
    font-size: 18px;
    line-height: 33px;
    text-align: center;
    background: #000;
    background: rgba($color: #000, $alpha: 0.7);
    border-radius: 7px 7px 0 0;
  }
  .promotionLabel {
    position: absolute;
    top: 0;
    left: 0;
    width: 216px;
    height: 36px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/label.png');
    background-size: 100%;
    p {
      padding-right: 7px;
      color: #774d2d;
      font-weight: 500;
      font-size: 18px;
      line-height: 36px;
      text-align: right;
    }
  }
}

.dkillTitle {
  width: 288px;
  padding: 22px;
  color: #333;
  font-weight: bold !important;
  font-size: 25px;
  word-break: break-all;
  @extend .ellipsis;
  i {
    margin-left: -18px;
  }
}
.activityTag {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 0 22px;
  span {
    display: inline-block;
    flex-shrink: 0;
    margin-right: 7px;
    margin-bottom: 16px;
    padding: 2px 7px;
    color: #fe9766;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    background: #fef5f1;
    border-radius: 5px;
  }
}
.TimeHours {
  display: flex;
  justify-content: space-between;
  padding: 0 22px 98px 22px;
  p {
    color: #999;
    font-weight: 400;
    font-size: 22px;
  }
}
.foot {
  position: absolute;
  bottom: 20px;
  left: 0;
  display: flex;
  align-items: self-end;
  justify-content: space-between;
  width: 100%;
  padding:0 22px;
}
.coursePrice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  del {
    color: #ccc;
    font-size: 18px;
    line-height: 25px;
  }
  .showPic {
    display: flex;
    align-items: center;
    width: 100%;
    b {
      margin: 0 4px;
      color: #ff3938;
      font-weight: 500;
      font-size: 25px;
    }
    span {
      color: #ff3938;
      font-weight: bold;
      font-size: 36px;
    }
    .fontSty {
      font-size: 30px;
    }
  }
}
.addShopping {
  flex-shrink: 0;
  width: 72px;
  height: 43px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/shopping-btn2.png')
    no-repeat;
  background-size: 100%;
}
</style>
